import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { useCallback, useEffect, useState } from 'react';
import { useAudioManager } from '../..';
export function usePlayPause(audioRef) {
  var _useAudioManager = useAudioManager(),
      managerPlay = _useAudioManager.play;

  var _useState = useState(false),
      isPlaying = _useState[0],
      setIsPlaying = _useState[1];

  var togglePlay = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!audioRef.current.paused) {
              _context.next = 5;
              break;
            }

            _context.next = 3;
            return managerPlay(audioRef.current);

          case 3:
            _context.next = 6;
            break;

          case 5:
            audioRef.current.pause();

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [audioRef, managerPlay]);
  var play = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return managerPlay(audioRef.current);

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })), [audioRef, managerPlay]);
  var pause = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            audioRef.current.pause();

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  })), [audioRef]);
  useOnPlayPauseEvent(setIsPlaying, audioRef);
  return {
    isPlaying: isPlaying,
    togglePlay: togglePlay,
    play: play,
    pause: pause
  };
}
/**
 * The hook responsible for registering to the play/pause function and trigger the input function accordingly
 * @param setIsPlaying
 * @param audioRef
 */

function useOnPlayPauseEvent(setIsPlaying, audioRef) {
  useEffect(function () {
    var pause = function pause() {
      return setIsPlaying(false);
    };

    var play = function play() {
      return setIsPlaying(true);
    };

    var audioElem = audioRef.current;
    audioElem.addEventListener('pause', pause);
    audioElem.addEventListener('play', play);
    return function () {
      audioElem.removeEventListener('pause', pause);
      audioElem.removeEventListener('play', play);
    };
  }, [audioRef, setIsPlaying]);
}